/* eslint-disable jsdoc/newline-after-description */
/* eslint-disable jsdoc/no-types */
/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
export enum ResponseType {
    Unauthorized = 1,
    NoInternetConnection,
    Timeout,
    ServerError,
    ValidationFailed,
    Unknown,
}

export class CustomError {
    private _code: string;
    private _statusCode: number;
    private _message: string;
    private _data: any;


    constructor(code: string, statusCode: number, message: any, data: any) {
        this._code = code;
        this._statusCode = statusCode;
        this._message = message;
        this._data = data;
    }

    /**
     * Getter code
     * @return {string}
     */
    public get code(): string {
        return this._code;
    }

    /**
     * Getter statusCode
     * @return {number}
     */
    public get statusCode(): number {
        return this._statusCode;
    }

    /**
     * Getter statusCode
     * @return {number}
     */
    public get type(): ResponseType {
        switch (this.statusCode) {
            case 0:
                if (this.message.includes('Timeout has occurred')) {
                    return ResponseType.Timeout;
                } else {
                    return ResponseType.NoInternetConnection;
                }
            case 401:
                return ResponseType.Unauthorized;
            case 504:
                return ResponseType.Timeout;
            case 500:
                return ResponseType.ServerError;
            case 422:
                return ResponseType.ValidationFailed;
            default:
                return ResponseType.Unknown;
        }
    }

    /**
     * Getter message
     * @return {string}
     */
    public get message(): string {
        return this._message;
    }

    public get data(): any {
        return this._data;
    }

    /**
    * Setter code
    * @param {string} value
     */
    public set code(value: string) {
        this._code = value;
    }

    public set data(value: any) {
        this._data = value;
    }

    /**
     * Setter statusCode
     * @param {number} value
     */
    public set statusCode(value: number) {
        this._statusCode = value;
    }

    /**
     * Setter message
     * @param {string} value
     */
    public set message(value: string) {
        this._message = value;
    }


}
